import { connect } from 'react-redux'
import View from 'components/nxt_currency/View'

const mapStateToProps = state => {
  return {
    currencyConfiguration: state.data.domain.domainConfiguration.currencyConfiguration,
    iconName: state.data.domain.domainConfiguration.currencyIcon,
    hasIconLeftSide: state.data.domain.domainConfiguration.hasCurrencyIconToLeft,
  }
}
export default connect(
  mapStateToProps,
  null,
)(View)
